import React, { useState, useMemo } from "react";
import { Row, Col, Modal, Form } from "react-bootstrap";
import '../styles/ShopListScreen.css'
import { colors, initialLanguage } from "../configs";
import { findInArray, searchFilterFunction } from "../Utility/function";
import { useSelector } from "react-redux";
import { NumberYMD } from "../Utility/dateTime";

const { transparent } = colors;


function Modal_Language({
  backdrop=true, // true/false/static
  animation=true,
  show,
  onHide,
  centered=true,
  size='lg',
  onClick
}) {

  const defaultLanguage = window.navigator.language;
  const suggest = findInArray(initialLanguage,'brev',defaultLanguage);
  const [search, setSearch] = useState('');

  const display = useMemo(()=>{
      if(!search){
        return initialLanguage
      }
      return searchFilterFunction(initialLanguage,search,'name')
  },[search])


  return (
    <Modal
      backdrop={backdrop}
      animation={animation}
      show={show}
      onHide={onHide}
      centered={centered}
      // className='loading-screen'
      style={styles.container}
    //   size={size}
    >

      <Modal.Body 
          style={styles.container2}  
      >
          <Row>
            {suggest
                ?<div onClick={()=>{onHide();onClick(suggest)}}  style={styles.container3} >
                  <h1 style={styles.text} >{suggest.image}</h1>
                </div>
                :null
            }
            <Form className="d-flex">
                <Form.Control
                    type="search"
                    placeholder={'search'}
                    className="me-2 rounded-pill"
                    aria-label="Search"
                    onChange={(event)=>{setSearch(event.target.value)}}
                />
            </Form>
            <Row >
                {display.map((item)=>{
                  const { name, image, id } = item;
                  return(
                    <Col key={id} 
                          onClick={()=>{onHide();onClick(item)}}  lg='4' xs='4'  >
                        <div style={styles.container4} >
                            <h1>{image}</h1>
                            <h5>{name}</h5>
                        </div>
                    </Col>
                  )
                })}
            </Row>
          </Row>
      </Modal.Body>
    </Modal>
  );
};

const styles = {
    container : {
      backgroundColor:transparent,borderRadius:30
    },
    container2 : {
      borderRadius:30
    },
    container3 : {
      display:'flex',justifyContent:'center',alignItems:'center'
    },
    container4 : {
      display:'flex',flexDirection:'column',alignItems:'center',cursor:'pointer',padding:10,margin:10
    },
    text : {
      fontSize:'120px'
    }
}

export default Modal_Language;

